import { forIn } from 'lodash'

export const IMAGE_PATH = '/images'

export const makeStateToParams = (object: { [key: string]: string | number }) => {
  let url = '?'

  forIn(object, (value, key) => {
    url += `&${key}=${value}`
  })

  return url
}
